import React from 'react';

// mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { DialogActions, DialogTitle, Typography } from '@mui/material';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {
  open: boolean,
  onClose: (e: any) => void,
  handleRemove: () => void,
  chatName: string,
};

const ConfirmLeaveChat:React.FC<Props> = ({ open, onClose, handleRemove, chatName }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      aria-describedby="confirm-leave-dialog-slide-description"
    >
      <DialogTitle id="confirm-leave-dialog-title">
        {`Do you want to leave the chat: ${chatName}?`}
      </DialogTitle>
      <DialogContent sx={{ minWidth: '450px', maxWidth: '100%' }}>
        <Typography>
          This action cannot be undone
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pt: 4 }}>
        <Button variant="text" onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="error" onClick={handleRemove}>Leave</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmLeaveChat;
